module.exports = __webpack_public_path__ + "static/media/icon-kitchen.3cfe2c4b.svg";